import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { MovieData } from '../assets/MovieData';
import CardSlider from './CardSlider';

const Details = () => {
  const { id } = useParams();
  const [details, setDetails] = useState('');

  useEffect(() => {
    const allData = MovieData.filter((data) => data.id == id);
    setDetails(allData[0].movie_detail);
    console.log(allData[0]);
  }, []);

  return (
    <>
      <div className='backdrop-blur-lg  bg-gray-400 '>
        <div
          className='blur-none grid grid-cols-4 gap-4 container mx-auto  py-10 '
          style={{
            boxShadow: ' 0 8px 32px 0 rgba( 31, 38, 135, 0.37 )',
            backdropFilter: ' blur( 3.5px )',

            borderRadius: '10px',
          }}
        >
          <div className='col-span-1'>
            <img
              className='rounded-2xl'
              src={details.img}
              alt=''
            />
          </div>

          <div className='col-span-3 content-center grid text-left'>
            <h2 className='font-bold text-3xl'>{details.title} </h2>
            <ul>
              <li>Category:</li>
              <li>Actor:</li>

              <li>Release : {details.release} </li>
            </ul>
            <ul>
              <li>Show Time</li>
              <li>Watch Trailer</li>
            </ul>
            <h4 className='font-medium text-xl py-2'>Overview</h4>
          </div>
        </div>
      </div>
      <CardSlider />
    </>
  );
};

export default Details;
